import { createFileRoute } from '@tanstack/react-router';
import { InvitationLinkPage } from '@/features/invitations';

/** Public: the link of an invitation email. It only moves the token out of the address bar. */
export const Route = createFileRoute('/invitations/$token')({
  component: InvitationLinkRoute,
});

function InvitationLinkRoute() {
  const { token } = Route.useParams();
  return <InvitationLinkPage token={token} />;
}
